import { apiAuthClient } from '../../helpers';
import {
  GetExtDocumentMetaRequestType,
  GetExtDocumentMetaResponseType,
} from '../types';

export const getExtDocumentMeta = async (
  request: GetExtDocumentMetaRequestType,
) => {
  const url = `/api/v2/documents/${request.pathParams.docSlug}/meta`;

  const response = await apiAuthClient.get<GetExtDocumentMetaResponseType>(
    url,
    {
      params: { dontRetry: true },
      headers: request.headers,
    },
  );

  return response.data;
};
